/* eslint-disable camelcase */
import { getCookie } from '../../../client/cookie/cookieService';
import decodeToken from '../decodeToken';
import { TEALIUM_SCHEMA_USER } from './constants';

export const constructUserData = (decoder = decodeToken) => {
  const token = getCookie('lmdstok');
  const isSignedIn = !!token;
  const annonymousUserId = getCookie('rcauid');
  const countryCode = getCookie('Country');
  const {
    uid,
    locke_id,
  } = decoder(token);

  return {
    user: {
      schema: TEALIUM_SCHEMA_USER,
      data: {
        user_login_status: isSignedIn ? 'logged_in' : 'not_logged_in',
        rcauid: annonymousUserId,
        country_code: countryCode,
        my_rca_id: uid,
        locke_id,
      },
    },
  };
};
